import styled from 'styled-components';
import { COLORS, DEVICES, pickThemeFontStyles } from '@/theme';

export const StyledChartsCard = styled.div.attrs({
  'data-pdf-block': 'true',
  'data-pdf-order': '2',
})`
  background: ${COLORS.WHITE};
  border: 1px solid ${COLORS.BRIGHT_GRAY};
  border-radius: 0.75rem;
  padding: 1.25rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    padding: 1.5rem;
  }
`;

export const StyledChartsHeader = styled.div.attrs({ 'data-pdf-atomic': 'true' })`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.25rem;
  flex-wrap: wrap;

  .ant-select .ant-select-arrow {
    margin-top: -1px !important;
  }
`;

export const StyledChartsTitle = styled.h3`
  margin: 0;
  ${pickThemeFontStyles('18', '24', 'SEMI_BOLD')};
  color: ${COLORS.BLACK};
`;

export const StyledChartsGrid = styled.div.attrs({ 'data-pdf-charts-grid': 'true' })`
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.5rem;

  @media screen and ${DEVICES.LAPTOP_S} {
    grid-template-columns: repeat(3, 1fr);
  }

  [data-pdf-exporting='true'] & {
    display: block;
    width: 100%;
    gap: 0;
  }
`;

export const StyledChartColumn = styled.div.attrs({
  'data-pdf-chart-column': 'true',
  'data-pdf-atomic': 'true',
})`
  min-width: 0;

  [data-pdf-exporting='true'] & {
    display: block;
    width: 100%;
    max-width: 100%;
    overflow: hidden;
    margin: 0 0 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const StyledChartTitle = styled.div`
  ${pickThemeFontStyles('14', '20', 'SEMI_NORMAL')};
  margin-bottom: 0.5rem;
  color: ${COLORS.BLACK};
`;

export const StyledChartSummary = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 0.75rem;
  ${pickThemeFontStyles('12', '16', 'NORMAL')};
`;

export const StyledSummaryRow = styled.div<{ $color?: string }>`
  color: ${({ $color }) => $color || COLORS.BLACK};
`;

export const StyledChartWrapper = styled.div.attrs({ 'data-pdf-chart-wrap': 'true' })`
  width: 100%;
  height: 220px;

  [data-pdf-exporting='true'] & {
    height: 280px;
    overflow: hidden;
  }
`;
